import qoalaStorage from '~/core/Storage';

export default () => ({
  policy: qoalaStorage.getItem('policy'),
  benefits: qoalaStorage.getItem('benefits'),
  cancelTokenAxios: {}
});
